import {
  EditGPDStartRegistrationTask,
  GPDStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGpdLibraryFields } from "../../../schema/gpd-schema-library";

const sharedTitle = (type: FormType | undefined) => `GPD Start Registratie ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GPD Start Registratie formulier. ${getDocsLinkMarkdown(
  "GPD"
)}`;

const sharedSourcedocumentData = {
  type: "object" as const,
  required: ["objectIdAccountableParty"],
  properties: pickGpdLibraryFields(["objectIdAccountableParty", "publiclyAvailable"]),
};

const getGpdStartRegistrationCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<GPDStartRegistrationTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "qualityRegime", "deliveryAccountableParty"],
      properties: pickGpdLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

const getGpdStartRegistrationEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGPDStartRegistrationTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      required: [
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
        "correctionReason",
      ],
      properties: {
        ...pickGpdLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGpdLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

export function getGpdStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGPDStartRegistrationTask>;
export function getGpdStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<GPDStartRegistrationTask>;
export function getGpdStartRegistrationSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditGPDStartRegistrationTask> | SchemaForFormData<GPDStartRegistrationTask>;
export function getGpdStartRegistrationSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing
    ? getGpdStartRegistrationEditSchema(type)
    : getGpdStartRegistrationCreateSchema(type);
}
